import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { ITenant } from 'src/types/tenant.type';

interface ITenantStore {
  active?: ITenant;
  list: ITenant[];
}

const tenantSlice = createSlice<ITenantStore, SliceCaseReducers<ITenantStore>>({
  name: 'tenant',
  initialState: {
    active: undefined,
    list: [],
  },
  reducers: {
    setTenant: (state, { payload }: PayloadAction<ITenant | undefined>) => {
      return { ...state, active: payload || undefined };
    },
    setListTenant: (state, { payload }: PayloadAction<ITenant[]>) => {
      return { ...state, list: payload };
    },
  },
});

export const { setTenant, setListTenant } = tenantSlice.actions;

export default tenantSlice.reducer;
